import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PaginationComponent } from "./pagination/pagination.component";
import { plantingsComponent } from "./plantings/plantings";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FeedComponent } from "./feed/feed.component";
import { GatewaysComponent } from "./gateways/gateways.component";
import { HarvestsComponent } from "./harvests/harvests.component";
import { TwoDigitDecimaNumberDirective } from "./directives/twodecimal";
import { SheetSwipeDirective } from "./directives/sheet-swipe.directive";
import { FilterSidebarComponent } from "./filter-sidebar/filter-sidebar";
import { FilterItemDirective, FilterSlotDirective } from "./filter-sidebar/filter-pin.directive";
import { FilterPinRowComponent } from "./filter-sidebar/filter-pin-row/filter-pin-row";
import { PondSelectComponent } from "./pond-select/pond-select";
import { NavScrollDirective } from "./directives/nav-scroll.directive";
import { FeederFormComponent } from "./update-device-dynamic/feeder/feeder-form.component";
import { UpdateDeviceDynamicComponent } from "./update-device-dynamic/update-device-dynamic.component";
import { RationModalComponent } from "./ration-modal/ration-modal.component";

import { TranslateModule } from "@ngx-translate/core";
import { ObservationsComponent } from "./observations/observations.component";
import { ImageCropperComponent } from "./ImageCropper/imageCropper";
import { ImageCropperModule } from "ngx-image-cropper";
import { ScrollSpyDirective } from "./settings-modal/scroll-spy.directive";
import { SpeedComponent } from "./speed/speed";
import { SpeedConfigComponent } from "./speed-config/speed-config.component";
import { SettingModalComponent } from "./settings-modal/settings-modal.component";
import { AlertsSettingComponent } from "./settings-modal/alerts/alerts";
import { LoaderComponentSettings } from "./settings-modal/loader/loader.component";
import { SafeHtmlPipe } from "../core/pipe/html.pipe";
import { TitleComponent } from "./title/title";
import { ExtendedHarvestComponent } from "./extended-harvest/extended-harvest.component";
import { NgbAccordionModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Models3dComponent } from "./models3d/models3d";

import { CalendarComponent } from "./calendar/calendar";
import { FullCalendarModule } from "@fullcalendar/angular"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from "@fullcalendar/interaction"; // a plugin!

import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";
import { QrComponent } from "./qr/qr";
import { AutomaticValueComponent } from "./automatic_value/automatic_value";
import { CalibrationFoodComponent } from "./food-calibration/food";
import { FormWaterwiseComponent } from "./update-device-dynamic/waterwise/waterwise-form.component";
import { AgmCoreModule, GoogleMapsAPIWrapper } from "@agm/core";
import { environment } from "../../environments/environment";
import { ProgressBarComponent } from "./progress_bar/progress_bar";
import { PanelAlertsComponent } from "./panel-alerts/panel-alerts";
import { PanelCommandsComponent } from "./panel-alerts/views/commands/commands";
import { PanelCommandButtonComponent } from "./panel-alerts/views/commands/command-button/command-button";
import { PanelFeedersComponent } from "./panel-alerts/views/feeders/feeders";
import { PanelFeederCardComponent } from "./panel-alerts/views/feeders/feeder-card/feeder-card";
import { PanelCommandRowComponent } from "./panel-alerts/views/feeders/command-row/command-row";
import { PanelFooterComponent } from "./panel-alerts/views/footer/footer";
import { MonitorAlertsComponent } from "./panel-alerts/views/monitor/monitor";
import { MenuEmptyComponent } from "./panel-alerts/views/empty/empty";

import { TimeQueryComponent } from "./time-query/time-query";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MinuteTimerComponent } from "./minute_timer/minute_timer";
import { DateSliderComponent } from "./date-slider/date-slider";
import { TestFeedComponent } from "./feed/test/test";
import { ViewAlertComponent } from "./feed/test/view_alert/view_alert";
import { CustomSelectComponent } from "./custom_select/custom_select";
import { SearchSelectComponent } from "./search_select/search_select";
import { ViewExcelComponent } from "./view-excel/view-excel";
import { ViewFuzzyLogicComponent } from "./view_fuzzy_logic/view_fuzzy_logic";
import { DndDirective } from "../core/directives/dnd.directive";
import { MapaComponent } from "./map/map";
import { MarkerAlertComponent } from "./map/marker/marker";
import { LoadingTimeComponent } from "./loading/loading_time/loading_time";

import { LoadingModule } from "./loading/loading.module";
import { ConfigSensorsDeviceModule } from "./config_sensors_device/config_sensors_device.module";
import { MarkerWaterwiseComponent } from "./map/marker_waterwise/marker_waterwise";
import { ViewContentDeviceModule } from "./content_device/content.module";
import { VirtualWeightModule } from "./virtual_weight/virtual_weight.module";
import { EchartModule } from "./echart/echart.module";
import { ImageColorModule } from "./image_color/image_color.module";
import { SettingFeedersModule } from "./settings-feeders/settings-feeders.module";
import { FrameDeviceDynamicModule } from "./frames_device_dynamic/frame_device.module";
import { IconBatteryModule } from "./icon_battery/icon_battery.module";
import { DynamicObjectBuilderComponent } from "./dynamicObjectBuilder/dynamicObjectBuilder";

FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin
]);
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    NgbModule,
    ImageCropperModule,
    NgxQRCodeModule,
    NgbAccordionModule,
    ViewContentDeviceModule,
    FullCalendarModule,
    AgmCoreModule.forRoot({
      apiKey: environment.apikeyMap
    }),
    ScrollingModule,
    LoadingModule,
    ConfigSensorsDeviceModule,
    VirtualWeightModule,
    EchartModule,
    ImageColorModule,
    FrameDeviceDynamicModule,
    IconBatteryModule
  ],
  providers: [
    PaginationComponent,
    plantingsComponent,
    FeedComponent,
    GatewaysComponent,
    HarvestsComponent,
    FeederFormComponent,
    RationModalComponent,
    TimeQueryComponent,
    LoaderComponentSettings,
    ObservationsComponent,
    ImageCropperComponent,
    SpeedComponent,
    SettingModalComponent,
    SettingFeedersModule,
    SpeedConfigComponent,
    TitleComponent,
    ExtendedHarvestComponent,
    CalendarComponent,
    QrComponent,
    Models3dComponent,
    AutomaticValueComponent,
    CalibrationFoodComponent,
    FormWaterwiseComponent,
    GoogleMapsAPIWrapper,
    ProgressBarComponent,
    PanelAlertsComponent,
    PanelCommandsComponent,
    PanelCommandButtonComponent,
    PanelFeedersComponent,
    PanelFeederCardComponent,
    PanelCommandRowComponent,
    PanelFooterComponent,
    MonitorAlertsComponent,
    MenuEmptyComponent,
    MinuteTimerComponent,
    DateSliderComponent,
    TestFeedComponent,
    ViewAlertComponent,
    CustomSelectComponent,
    ViewExcelComponent,
    ViewFuzzyLogicComponent,
    MapaComponent,
    MarkerAlertComponent,
    MarkerWaterwiseComponent,
    LoadingTimeComponent,
    DynamicObjectBuilderComponent
  ],
  declarations: [
    PaginationComponent,
    plantingsComponent,
    FeedComponent,
    GatewaysComponent,
    HarvestsComponent,
    TwoDigitDecimaNumberDirective,
    SheetSwipeDirective,
    FilterSidebarComponent,
    FilterSlotDirective,
    FilterItemDirective,
    FilterPinRowComponent,
    PondSelectComponent,
    NavScrollDirective,
    TimeQueryComponent,
    FeederFormComponent,
    UpdateDeviceDynamicComponent,
    RationModalComponent,
    LoaderComponentSettings,
    ObservationsComponent,
    ImageCropperComponent,
    ScrollSpyDirective,
    SpeedComponent,
    SettingModalComponent,
    SpeedConfigComponent,
    AlertsSettingComponent,
    SafeHtmlPipe,
    TitleComponent,
    ExtendedHarvestComponent,
    CalendarComponent,
    QrComponent,
    Models3dComponent,
    AutomaticValueComponent,
    CalibrationFoodComponent,
    FormWaterwiseComponent,
    ProgressBarComponent,
    PanelAlertsComponent,
    PanelCommandsComponent,
    PanelCommandButtonComponent,
    PanelFeedersComponent,
    PanelFeederCardComponent,
    PanelCommandRowComponent,
    PanelFooterComponent,
    MonitorAlertsComponent,
    MenuEmptyComponent,
    MinuteTimerComponent,
    DateSliderComponent,
    TestFeedComponent,
    ViewAlertComponent,
    CustomSelectComponent,
    SearchSelectComponent,
    ViewExcelComponent,
    ViewFuzzyLogicComponent,
    DndDirective,
    MapaComponent,
    MarkerAlertComponent,
    MarkerWaterwiseComponent,
    LoadingTimeComponent,
    DynamicObjectBuilderComponent
  ],
  exports: [
    CommonModule,
    SheetSwipeDirective,
    FilterSidebarComponent,
    FilterSlotDirective,
    FilterItemDirective,
    PondSelectComponent,
    NavScrollDirective,
    RouterModule,
    PaginationComponent,
    plantingsComponent,
    FeedComponent,
    GatewaysComponent,
    HarvestsComponent,
    FeederFormComponent,
    UpdateDeviceDynamicComponent,
    TimeQueryComponent,
    RationModalComponent,
    LoaderComponentSettings,
    ObservationsComponent,
    ImageCropperComponent,
    SpeedComponent,
    SettingModalComponent,
    SettingFeedersModule,
    SpeedConfigComponent,
    TitleComponent,
    ExtendedHarvestComponent,
    CalendarComponent,
    QrComponent,
    NgbModule,
    Models3dComponent,
    AutomaticValueComponent,
    CalibrationFoodComponent,
    FormWaterwiseComponent,
    ProgressBarComponent,
    PanelAlertsComponent,
    PanelCommandsComponent,
    PanelCommandButtonComponent,
    PanelFeedersComponent,
    PanelFeederCardComponent,
    PanelCommandRowComponent,
    PanelFooterComponent,
    MonitorAlertsComponent,
    MenuEmptyComponent,
    MinuteTimerComponent,
    DateSliderComponent,
    TestFeedComponent,
    ViewAlertComponent,
    CustomSelectComponent,
    SearchSelectComponent,
    ViewExcelComponent,
    ViewFuzzyLogicComponent,
    MapaComponent,
    MarkerAlertComponent,
    MarkerWaterwiseComponent,
    LoadingTimeComponent,
    ConfigSensorsDeviceModule,
    LoadingModule,
    VirtualWeightModule,
    ViewContentDeviceModule,
    ImageColorModule,
    EchartModule,
    FrameDeviceDynamicModule,
    IconBatteryModule,
    DynamicObjectBuilderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {}
